export default function Card({ children }) {
  return (
    <div className="mt-5 bg-white text-gray-800 text-md font-normal px-8 py-6 rounded-lg shadow-md">
      {children}
    </div>
  );
}
